import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'

import { CmsBlogCategory } from 'types/cms/collection-types'

/**
 * Get the blog categories from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsBlogCategory[]>}
 */
const getBlogCategories = async (locale: Language = Language.DUTCH): Promise<CmsBlogCategory[]> => {
  try {
    const { data } = await axios.get<CMSApiResponseBody<CmsBlogCategory[]>>(`${process.env.CMS_API_URL}/blog-categories?locale=${locale}`)

    return data.data
  } catch (_) {
    return []
  }
}

export default getBlogCategories
